import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./landing-page.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./landing-page.component.scss?ngResource";
import { Component } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { AutoUnsub } from "../../shared/decorators/autounsub.decorator";
import { AuthService } from "../../shared/services/auth/auth.service";
import { LandingPageConstants } from "./landing-page.constants";
import { LocalStorageService } from "../../shared/services/storage/local-storage.service";
import { AppControllerService } from "../../app-controller.service";
import { AppConfig } from "../../app.config";
let LandingPageComponent = class LandingPageComponent {
    dialogRef;
    authService;
    localStorage;
    appController;
    loginButtonLabel = LandingPageConstants.LOGIN_TEXT;
    municipalName;
    municipalContent;
    image_Url;
    logo;
    aflaPortal;
    aboutPortal;
    descriptionAfla;
    portalOnLine;
    acceptDisclaimerObservable;
    config;
    constructor(dialogRef, authService, localStorage, appController) {
        this.dialogRef = dialogRef;
        this.authService = authService;
        this.localStorage = localStorage;
        this.appController = appController;
        this.config = AppConfig.settings;
        this.municipalContent = this.config.municipalData.municipalContent;
        this.municipalName = this.config.municipalData.municipalName;
        this.image_Url = this.config.municipalData.imagefirstslide;
        this.logo = this.config.municipalData.aflalogo;
        this.aflaPortal = this.config.municipalData.aflaName;
        this.aboutPortal = this.config.municipalData.aboutAfla;
        this.descriptionAfla = this.config.municipalData.descriptionOfAfla;
        this.portalOnLine = this.config.municipalData.aflaOnline;
    }
    ngOnInit() {
    }
    login($event) {
        this.appController.landingPageShown = true;
        this.authService.redirectAuthenticate();
        this.dialogRef.close();
    }
    static ctorParameters = () => [
        { type: MatDialogRef },
        { type: AuthService },
        { type: LocalStorageService },
        { type: AppControllerService }
    ];
};
LandingPageComponent = __decorate([
    Component({
        standalone: false,
        selector: "app-landing-page",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    }),
    AutoUnsub()
], LandingPageComponent);
export { LandingPageComponent };
